var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"w-100 vh-100",attrs:{"src":_vm.dashboardURL,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }